import { render, staticRenderFns } from "./Traingame.vue?vue&type=template&id=2195b74e&scoped=true"
import script from "./Traingame.vue?vue&type=script&lang=js"
export * from "./Traingame.vue?vue&type=script&lang=js"
import style0 from "./Traingame.vue?vue&type=style&index=0&id=2195b74e&prod&scoped=true&lang=css"
import style1 from "./Traingame.vue?vue&type=style&index=1&id=2195b74e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195b74e",
  null
  
)

export default component.exports